import React from 'react';

function HRResolveTicket() {
  return <div>HRResolveTicket</div>;
}

export default HRResolveTicket;
